import {
  cva
} from "../../../chunk-6A7LB5UJ.mjs";
import "../../../chunk-QJVDQ4DQ.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/TextField/textFieldVariants.ts
var textFieldVariants = cva("buyscout-tf", {
  variants: {
    variant: { outlined: "buyscout-tf--variant-outlined", subtle: "buyscout-tf--variant-subtle", glass: "buyscout-tf--variant-glass" },
    size: { sm: "buyscout-tf--size-sm", md: "buyscout-tf--size-md", lg: "buyscout-tf--size-lg", xl: "buyscout-tf--size-xl" },
    accessoryLayout: { "attached": "", "inline": "buyscout-tf--accessory-inline", "responsive-toolbar": "buyscout-tf--accessory-responsive-toolbar" }
  }
});
export {
  textFieldVariants
};
//# sourceMappingURL=textFieldVariants.mjs.map